import { RoutePath } from "#utils/route";
import { NetworkDetailRoute } from "#routes/organization/networks/[networkId]/detail";

export const NetworkEditRoute = NetworkDetailRoute.concat(
  new RoutePath({
    path: "/edit",
    title: "Edit Network",
  })
);
